import {
  SERVICE_HOLDER_EMOTIONAL_STATUS_AFFABLE,
  SERVICE_HOLDER_EMOTIONAL_STATUS_APATHETIC,
  SERVICE_HOLDER_EMOTIONAL_STATUS_CALMED,
  SERVICE_HOLDER_EMOTIONAL_STATUS_CONFORMIST,
  SERVICE_HOLDER_EMOTIONAL_STATUS_CONVERSATIONAL,
  SERVICE_HOLDER_EMOTIONAL_STATUS_EXIGENT,
  SERVICE_HOLDER_EMOTIONAL_STATUS_FAMILIAR,
  SERVICE_HOLDER_EMOTIONAL_STATUS_FRIENDLY,
  SERVICE_HOLDER_EMOTIONAL_STATUS_FUNNY,
  SERVICE_HOLDER_EMOTIONAL_STATUS_HOMELIKE,
  SERVICE_HOLDER_EMOTIONAL_STATUS_INSECURE,
  SERVICE_HOLDER_EMOTIONAL_STATUS_LAZY,
  SERVICE_HOLDER_EMOTIONAL_STATUS_MESSY,
  SERVICE_HOLDER_EMOTIONAL_STATUS_NERVOUS,
  SERVICE_HOLDER_EMOTIONAL_STATUS_NICE,
  SERVICE_HOLDER_EMOTIONAL_STATUS_OBSESSIVE,
  SERVICE_HOLDER_EMOTIONAL_STATUS_PERSEVERANT,
  SERVICE_HOLDER_EMOTIONAL_STATUS_QUIET,
  SERVICE_HOLDER_EMOTIONAL_STATUS_SENSIBLE,
  SERVICE_HOLDER_EMOTIONAL_STATUS_SENTIMENTAL,
  SERVICE_HOLDER_EMOTIONAL_STATUS_SILENT,
  SERVICE_HOLDER_EMOTIONAL_STATUS_SOCIABLE,
  SERVICE_HOLDER_EMOTIONAL_STATUS_STRONG_CHARACTER,
  SERVICE_HOLDER_EMOTIONAL_STATUS_SUSPICIOUS,
} from "./serviceHolder";

const options = [
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_CALMED,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_PERSEVERANT,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_FRIENDLY,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_INSECURE,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_OBSESSIVE,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_SENSIBLE,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_NERVOUS,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_SENTIMENTAL,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_APATHETIC,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_QUIET,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_AFFABLE,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_CONFORMIST,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_LAZY,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_MESSY,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_SUSPICIOUS,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_STRONG_CHARACTER,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_EXIGENT,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_FAMILIAR,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_FUNNY,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_HOMELIKE,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_NICE,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_SILENT,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_SOCIABLE,
  },
  {
    value: SERVICE_HOLDER_EMOTIONAL_STATUS_CONVERSATIONAL,
  },
];

export function emotionalStatusList() {
  return options;
}
